import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2DataTaskService {
    constructor(private datatask: DataTaskService) {}

    public async getSettings(): Promise<P2DataTaskSettingsGet> {
        return (await this.datatask.Post(2157))[0];
    }

    public async list(params: P2DataTaskListParams): Promise<P2DataTaskItem[]> {
        return this.datatask.Post(10, params);
    }

    public async getDataTask(params: GetP2DataTaskParams): Promise<P2DataTaskGet> {
        return (await this.datatask.Post(11, params))[0];
    }

    public async saveDataTask(dataTask: P2DataTaskGet): Promise<P2DataTaskSaveResponse> {
        return (await this.datatask.Post(12, dataTask))[0];
    }
}

export interface P2DataTaskSettingsGet {
    searchtext: string;
}

export interface P2DataTaskListParams {
    searchtext: string;
}

export interface P2DataTaskItem extends Item {
    item_state?: string;
}

export interface GetP2DataTaskParams {
    p2_datatask_keyno: string;
}

export interface P2DataTaskGet {
    p2_datatask_keyno: string;
    proc_name: string;
    manual_parm: '0' | '1';
    is_report: '0' | '1';
    set_parms: '0' | '1';
    encoded_parms: '0' | '1';
    encoded_data: '0' | '1';
    reg_datetime: string;
    mod_datetime: string;
}

export interface P2DataTaskSaveResponse {
    iserror: '0' | '1';
    message: string;
}
